import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import { cn } from 'ui/lib/utils'

type SuggestionListProps = {
  onSuggestionSelect: (translation: string) => void
  translations: string[]
  className?: string
}

// TODO: improve a11y of this component
export const SuggestionsList = ({ translations, onSuggestionSelect, className }: SuggestionListProps) => {
  const [active, setActive] = useState(0)
  const { t } = useTranslation()

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.code === 'ArrowUp') setActive(prev => Math.max(0, prev - 1))

      if (e.code === 'ArrowDown') setActive(prev => Math.min(translations.length - 1, prev + 1))

      if (e.code === 'Enter') {
        e.stopPropagation()
        e.preventDefault()
        onSuggestionSelect(translations[active] as string)
      }
    }

    document.addEventListener('keydown', onKeyDown)

    return () => document.removeEventListener('keydown', onKeyDown)
  }, [active, onSuggestionSelect, translations])

  return (
    <ul
      aria-label={t('Variants')}
      className={clsx(
        'z-50 flex w-full flex-wrap justify-between gap-1 overflow-hidden rounded-md border border-input border-slate-500 bg-white dark:border-slate-800 dark:bg-slate-800 dark:shadow-slate-700',
        'max-sm:mb-2 sm:absolute sm:-top-1 sm:-translate-y-full sm:flex-col',
        className,
      )}
    >
      {translations.map((translation, idx) => (
        <li key={translation} className="grow basis-1/4">
          <button
            className={cn(
              'h-full w-full border-input px-2 py-1 text-center sm:border-b sm:text-start',
              idx === active
                ? 'md:bg-blue-200 md:dark:bg-slate-500'
                : 'hover:bg-blue-100 dark:bg-slate-800 dark:hover:bg-slate-600',
            )}
            onClick={() => {
              onSuggestionSelect(translation)
            }}
            onMouseDown={e => e.preventDefault()}
            tabIndex={-1}
          >
            {translation}
          </button>
        </li>
      ))}
    </ul>
  )
}
